import React from "react";
import Logo from "componentsTemplate/Logo/Logo";
import SocialsList1 from "componentsTemplate/SocialsList1/SocialsList1";
import { CustomLink } from "data/types";
import LogoWhite from "componentsTemplate/Logo/LogoWhite";
import Link from "componentsTemplate/Link";

export interface WidgetFooterMenu {
  id: string;
  title: string;
  menus: CustomLink[];
}

const widgetMenus: WidgetFooterMenu[] = [
  {
    id: "5",
    title: "Quem Somos",
    menus: [
      { href: "/quem-somos", label: "Sobre a Radar" },
      { href: "/quem-somos", label: "Nossa história" },
      { href: "/quem-somos#perfil-quem-participa", label: "Perfil de quem participa" },
      { href: "/#nosso_alcance", label: "Nosso alcance" },
      { href: "/quem-somos", label: "Fundadoras" },
    ],
  },
  {
    id: "1",
    title: "Comunidades",
    menus: [
      { href: "/parceiros", label: "Parceiras" },
      { href: "/eventos", label: "Eventos" },
      { href: "/dicas-geral", label: "Dicas" },
      { href: "/contatos", label: "Contatos" },
      { href: "/social", label: "Radar social" },
    ],
  },
  {
    id: "2",
    title: "Classificados",
    menus: [
      { href: "/classificados", label: "Casas de Temporadas" },
      { href: "/classificados", label: "Veículos" },
      { href: "/classificados", label: "Imóveis" },
      { href: "/classificados", label: "Roupas" },
    ],
  },
  {
    id: "4",
    title: "Fale Conosco",
    menus: [
      { href: "/", label: "(11) 91234-5678" },
      // { href: "/", label: "Canais de atendimento" },
      { href: "/cadastro", label: "Quero ser uma radar" },
      { href: "/fale-conosco", label: "Fale conosco" },
    ],
  },
];

const Footer: React.FC = () => {
  const renderWidgetMenuItem = (menu: WidgetFooterMenu, index: number) => {
    return (
      <div key={index} className="text-sm">
        <h2 style={{color: '#987E5B'}} className="font-semibold text-primary-700 dark:text-neutral-200">
          {menu.title}
        </h2>
        <ul className="mt-5 space-y-4">
          {menu.menus.map((item, index) => (
            <li key={index}>
              <Link
                key={index}
                className="text-neutral-300 dark:text-neutral-300 hover:text-white dark:hover:text-white"
                href={item.href}
              >
                {item.label}
              </Link>
            </li>
          ))}
        </ul>
      </div>
    );
  };

  return (
    <>
      <div className="nc-Footer relative bg-[#333333] py-16 lg:py-28 border-t border-neutral-200 dark:border-neutral-700">
        <div className="container grid grid-cols-2 gap-y-10 gap-x-5 sm:gap-x-8 md:grid-cols-4 lg:grid-cols-5 lg:gap-x-10 ">
          <div className="grid grid-cols-4 gap-5 col-span-2 md:col-span-4 lg:md:col-span-1 lg:flex lg:flex-col">
            <div className="col-span-2 md:col-span-1" style={{ marginLeft: '-10px' }}>
              {/* <Logo /> */}
              <LogoWhite />
            </div>
            <div className="col-span-2 flex items-center md:col-span-3">
              <SocialsList1 className="flex items-center space-x-3 lg:space-x-0 lg:flex-col lg:space-y-2.5 lg:items-start" />
            </div>
          </div>
          { widgetMenus.map(renderWidgetMenuItem) }
        </div>
      </div> 

      <div style={{background: '#987E5B'}} className="bg-primary-600 flex justify-between flex-col md:flex-row items-center pt-3 pb-8 md:py-3 px-5 md:px-40 text-neutral-800 text-sm">
        <span>
          {/* Pegando o ano atual */}
          Todos os direitos reservados - Radar {new Date().getFullYear()} ©
          <a className="ms-5" target="blank" href="https://radarevoce.com.br/termos-de-uso">Termos de uso</a>
        </span>
        <span>
          Desenvolvido por <a href="">Deep Ocean</a>
        </span>
      </div>
    </>

  );
};

export default Footer;
